{
  "conversations": {
    "conversationsApp": "Communicatieapp",
    "locationId": "Locatie-ID",
    "idToken": "ID-token",
    "conversationRoutes": "Communicatieroutes",
    "conversationProviders": "Aanbieders van gesprekken",
    "viewTheListOfConversation": "View de List of gesprek Custom providers toegevoegd aan het Account here.",
    "logo": "Logo",
    "name": "Naam",
    "alias": "Alias",
    "type": "Type"
  }
}
